// ContainerType API
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RequestKeys,
} from '../hooks/useRequest'

type ContainerTypeRequests = {
    name: string,
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<undefined>,
    selector: {url: string},
    [RequestKeys.getContainerTypes]: RequestConfigFunction<{params: any}>,
}

const containerTypeRequests: ContainerTypeRequests = {
    name: 'ContainerType',
    get: ({
        id,
    }) => {
        return {
            url: `containertype/${id}`,
            method: 'GET',
        }
    },
    update: () => {
        return {
            url: 'containertype',
            method: 'PUT',
        }
    },
    selector: {
        url: 'containertype/filter-request/selector',
    },
    [RequestKeys.getContainerTypes]: (params) => {
        return {
            url: 'containertype/filter-request/all',
            method: 'POST',
            data: {
                ...params,
                rows: 50,
            },
        }
    },
}

export default containerTypeRequests
